<template>
  <div class="login-container">
    <img :src="'/img/Signup-Finish-transparent.png'" />
    <span class="title">Congratulations</span>
    <div class="login-content">
      <button @click="finish()" class="button-default big finish">
        <span>Go to Dashboard</span>
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "AddArtistWizardStepFinished",
  async created() {},
  computed: {
    ...mapState("addArtist", ["artists"])
  },
  methods: {
    async finish() {
      this.$store.commit("addArtist/reset");
      this.$emit("finish");
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  /* BG/type2 */
  //background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 300px;
  }
  .title {
    display: block;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    button.finish {
      width: 199px;
    }
  }
}
</style>
